// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  AdvertisementType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
  InputDoubleButton,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  advertisementTypeLabel,
} from 'common.language';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  item: $Model<'Advertisement'> | $ModelUpsertParams<'Advertisement'>;
  resourceData: Array<$Model<'Regatta'>>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const AdvertisementFieldsView = function ({
  item,
  main,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col sm={4}>
          <InputDoubleButton
            className={'mb-3'}
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col
          sm={8}
          xs={12}
        >
          <AvField
            label={t('Name')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Email')}
            name={'Email'}
            required
            type={'email'}
            value={item.Email}
          />
        </Col>
        <Col>
          <AvField
            label={t('Phone')}
            name={'Phone'}
            value={item.Phone}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Type')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              AdvertisementType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(advertisementTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
        <Col>
          <InputDateTime
            label={t('End date')}
            labelOpenCalendar={t('Open calendar')}
            name={'EndDate'}
            required
            timezone={main.timezone}
            value={item.EndDate}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Content')}
            name={'Content'}
            required
            type={'textarea'}
            value={item.Content}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Regatta')}
            name={'RegattaId'}
            type={'select'}
            value={item.RegattaId}
          >
            {item.RegattaId === null && (
              <option />
            )}
            {_.map(
              resourceData,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default AdvertisementFieldsView;
